import { ArrowLeft2, IconProps } from "iconsax-react";

const ArrowLeft = (props: IconProps) => (<ArrowLeft2 size="16" {...props} />)

export default ArrowLeft;
